import ImageWithPlaceholder from './ImageWithPlaceholder';

const Properties = ({ props, loading, error, handleHover, handleHoverOut } ) => {

	if (loading) return <div className="properties loading"><h5>Loading Properties...</h5></div>;
	if (error) return <div className="properties error"><p>Error: {error}</p></div>;

    return (
		<div className="properties">
            <div className="row">
				{props.map((prop) => (
					<div key={prop.id} className="col-6 col-md-6 col-lg-4">

						<a href={prop.link}>

							<div
								className="property-item"
								onMouseEnter={() => handleHover(prop.acf.latitude, prop.acf.longitude)}
								onMouseLeave={() => handleHoverOut()} // sets hoverCoords = null
							>

								<ImageWithPlaceholder
									src={prop._embedded['wp:featuredmedia'][0].link}
									alt={prop.title.rendered}
								/>

								<div className="property-body">

									{prop.title && (
										<h5 className="mb-1" dangerouslySetInnerHTML={{ __html: prop.title.rendered }} />
									)}

									{prop.excerpt && (
										<div dangerouslySetInnerHTML={{ __html: prop.excerpt.rendered }} />
									)}

								</div>
							</div>

						</a>
						
                    </div>
                ))}
            </div>
        </div>
    );

}

export default Properties;
